
import type { GuaInfo, Yao } from "@/types/common";
import { YY } from "@/types/common";
import { defineComponent, ref, computed } from "vue";
import Nzh from "nzh";
import {
  NCard,
  NRadioGroup,
  NRadio,
  NButton,
  NButtonGroup,
  NSpace,
} from "naive-ui";
import GuaView from "@/components/GuaView.vue";

const { cn: nzhcn } = Nzh;

const yaoLabelList = ["初爻", "二爻", "三爻", "四爻", "五爻", "上爻"];
type Yy2Label = (yy: YY) => "六" | "九";
const yy2Label: Yy2Label = (yy) => (yy === YY.ying ? "六" : "九");

const dropIcon = () => Math.random() >= 0.5;
const drop3Icon = () => new Array(3).fill(false).map(() => dropIcon());

export default defineComponent({
  name: "HomeView",
  components: {
    GuaView,
    NCard,
    NRadioGroup,
    NRadio,
    NButton,
    NButtonGroup,
    NSpace,
  },
  setup() {
    const guaViewRef = ref<InstanceType<typeof GuaView>>();
    const curYaoList = ref<Yao[]>(["0", "0", "0", "0", "0", "0"]);
    const calCurYaoList = computed(() =>
      curYaoList.value.map((item, idx) => ({
        yao: item,
        yaoIdx: idx + 1,
        oYy: item === "0" || item === "2" ? YY.ying : YY.yang,
        tYy: item === "3" || item === "2" ? YY.ying : YY.yang,
        isT: item === "0" || item === "3",
      }))
    );
    const curOriginYaoLabelList = computed(() =>
      calCurYaoList.value.map(({ oYy }, idx) => {
        const curValue = yy2Label(oYy);
        let curRes: string;
        if (idx === 0) {
          curRes = `初${curValue}`;
        } else if (idx === 5) {
          curRes = `上${curValue}`;
        } else {
          curRes = `${curValue}${nzhcn.encodeS(idx + 1)}`;
        }
        return curRes;
      })
    );
    const handleReset = () => {
      curYaoList.value = ["0", "0", "0", "0", "0", "0"];
      guaViewRef.value?.clearContent();
    };
    /* ***********start: generate gua**************** */
    const handleGenerate = () => {
      console.log(calCurYaoList.value);
      const totalTrans = calCurYaoList.value.filter(({ isT }) => isT).length;
      const oGuaId = calCurYaoList.value.map(({ oYy }) => oYy).join("");
      const tGuaId = calCurYaoList.value.map(({ tYy }) => tYy).join("");
      const guaInfo: GuaInfo = {
        totalTrans,
        oYao: calCurYaoList.value.map(({ yao }) => yao),
        oGuaId,
        tGuaId,
        isUseO: totalTrans <= 4,
        isUseT: totalTrans === 3 || totalTrans >= 5,
        yaoIdList: [] as [string, string][],
      };
      if (totalTrans === 0) {
        guaInfo.yaoIdList = [[oGuaId, "0"]];
      } else if (totalTrans === 1) {
        guaInfo.yaoIdList = [
          [oGuaId, `${calCurYaoList.value.find(({ isT }) => isT)?.yaoIdx}`],
        ];
      } else if (totalTrans === 2) {
        guaInfo.yaoIdList = calCurYaoList.value
          .filter(({ isT }) => isT)
          .sort((a, b) => b.yaoIdx - a.yaoIdx)
          .map(({ yaoIdx }) => [oGuaId, `${yaoIdx}`]);
      } else if (totalTrans === 3) {
        guaInfo.yaoIdList = [
          [oGuaId, "0"],
          [tGuaId, "0"],
        ];
      } else if (totalTrans === 4) {
        guaInfo.yaoIdList = calCurYaoList.value
          .filter(({ isT }) => !isT)
          .sort((a, b) => a.yaoIdx - b.yaoIdx)
          .map(({ yaoIdx }) => [oGuaId, `${yaoIdx}`]);
      } else if (totalTrans === 5) {
        guaInfo.yaoIdList = [
          [tGuaId, `${calCurYaoList.value.find(({ isT }) => !isT)?.yaoIdx}`],
        ];
      } else if (totalTrans === 6) {
        guaInfo.yaoIdList = [[tGuaId, "0"]];
      } else {
        window.alert("error: 找旦旦提个bug吧~");
        return;
      }
      console.log(totalTrans);
      guaViewRef.value?.generateGua(guaInfo);
    };
    /* ***********end: generate gua**************** */
    const handleEasyGenerate = () => {
      curYaoList.value = new Array(6)
        .fill("")
        .map(() => `${drop3Icon().filter((e) => !e).length}` as Yao);
      handleGenerate();
    };
    return {
      yaoLabelList,
      curYaoList,
      curOriginYaoLabelList,
      handleReset,
      guaViewRef,
      handleGenerate,
      handleEasyGenerate,
      nzhcn,
    };
  },
});
